import { Item } from '../types';

export const showPlayVideoButton = (item: Item) => {
    if (!item || !item.promoType) return false;

    const excludedTypes = ['BANNER', 'SUBSCRIPTION', 'TIER'];
    return !excludedTypes.includes(item.promoType);
};

export const showWatchlistButton = (item: Item) => {
    if (!item || !item.promoType) return false;

    const excludedTypes = ['CHANNEL', 'BANNER', 'SUBSCRIPTION', 'TIER', 'CATCHUP', 'LIVESTREAM', 'PPV', 'ROUTE'];
    return !excludedTypes.includes(item.promoType);
};

export const showDetailsButton = (item: Item) => {
    if (!item || !item.promoType) return false;

    const includedTypes = ['VOD', 'SERIES', 'SEASON', 'EPISODE', 'SUBSCRIPTION', 'TIER', 'PPV', 'CATCHUP'];
    return includedTypes.includes(item.promoType);
};

export const showReminderButton = (item: Item) => {
    if (!item || !item.promoType) return false;

    const includedTypes = ['PPV'];
    return includedTypes.includes(item.promoType);
};
